import styled from 'styled-components'

export const StyledLobby = styled.div`
  #game-stand {
    position: absolute;
    left: 11%;
    bottom: 9%;
    cursor: pointer;
  }
  #current-user {
    pointer-events: none;
    position: absolute;
    right: 5px;
    bottom: 5px;
    font-size: 10px;
    color: gray;
  }
  #banner {
    position: absolute;
    cursor: pointer;
    top: 41.3%;
    bottom: 35.1%;
    left: 47.3%;
    right: 45.1%;
  }
`
